<template>
    <BasePanel :alvqa="alvqa" headline="lang_PUBLISHING_WORKS_CAPTION_INSRUMENTATION">
        <template v-slot:panelContent>
            <v-data-table         
                :headers="headers"
                :items="item"
                hide-default-footer
                :items-per-page="1000"
                :no-data-text="$t('lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')"
                class="noMinWidth"
            >
                <!-- alvqas for headers -->
                <template v-for="(header, i) in headers" v-slot:[`header.${header.value}`]>
                    <span :alvqa="header.alvqa" :key="i">{{ header.text }}</span>
                </template>

                <template v-slot:[`item.title`]="{ item }">
                    <div :alvqa="alvqa +'-list-row-'+ item.title.toLowerCase() + '-text-title'">
                        {{ getTitle(item.title) }}
                    </div>
                </template>
                <template v-slot:[`item.instruments`]="{ item }">
                    <div 
                        :alvqa="alvqa +'-list-row-'+ item.title.toLowerCase() +'-text-instruments'"
                        class="text-right"
                    >{{ item.instruments }}</div>
                </template>
                <template v-slot:[`item.musicians`]="{ item }">
                    <div 
                        :alvqa="alvqa +'-list-row-'+ item.title.toLowerCase() +'-text-musicians'"
                        class="text-right"
                    >{{ item.musicians }}</div>
                </template>
                <template v-slot:[`item.voices`]="{ item }">
                    <div 
                        :alvqa="alvqa +'-list-row-'+ item.title.toLowerCase() +'-text-voices'"
                        class="text-right"
                    >{{ item.voices }}</div>
                </template>
            </v-data-table>
        </template>
    </BasePanel>
</template>

<script>
import BasePanel from '@/components/_base/BasePanel'

export default {
    name: "WorksInstrumentationPanel",
    components: {
        BasePanel
    },
    props:{
        workAlvId: {
            type: String
        }
    },
    data() {
        return {
            alvqa: 'publishing-works-list-row-' + this.workAlvId + '-read-only-panel-instrumentation'
        }
    },
    computed: {
        item() {
            return this.$store.getters.getWorksInstrumentation
        },
        headers() {
            return [
                {
                    text: this.$t("lang_GENERIC_CAPTION_ITEM_TITLE"), 
                    align: "left", 
                    value: "title",
                    sortable: false,
                    alvqa: this.alvqa + '-header-title'
                },
                {
                    text: this.$t("lang_PUBLISHING_WORKS_CAPTION_INSTRUMENTS"), 
                    align: "right", 
                    value: "instruments",
                    sortable: false,
                    alvqa: this.alvqa + '-header-instruments'
                },
                {
                    text: this.$t("lang_PUBLISHING_WORKS_CAPTION_MUSICIANS"), 
                    align: "right", 
                    value: "musicians",
                    sortable: false,
                    alvqa: this.alvqa + '-header-musicians'
                },
                {
                    text: this.$t("lang_PUBLISHING_WORKS_CAPTION_VOICES"), 
                    align: "right", 
                    value: "voices",
                    sortable: false,
                    alvqa: this.alvqa + '-header-voices'
                }
            ]
        },
        
    },
    methods: {
        getTitle(titleValue){
            let instrumentationList = this.$store.getters.getInstrumentations[this.$i18n.locale]
            if(instrumentationList === undefined) {
                instrumentationList = this.$store.getters.getInstrumentations['en']
            }
            
            let match = instrumentationList.find(instrument => {
                    return instrument.value === titleValue
            })
            return match.text
        }
    },
    created() {
        this.$store.commit('setInstrumentations')
    },
}
</script>

<style>

</style>